export default "__VITE_ASSET__D38EPU9x__"